import { useIntl } from 'react-intl'

import TicketPart from './components/TicketPart/TicketPart'

import Money from '../Money/Money'
import './Goods.scss'

const Goods = ({ leftTitle = 'Title', description = 'description', price = 666, currency = 'Kč' }) => {
    const intl = useIntl()

    return (
        <>
            {/*<InfoLine text={'TEXT o členství v cinestar'} />*/}
            <div className={'goods goods__payment'}>
                <TicketPart className={'border-radius-right border-radius-left dashed-right'}>
                    <span className="left-title ">{leftTitle}</span>
                </TicketPart>
                <TicketPart className={'border-radius-left separator-right d-flex'}>
                    <span className="left-title text-basePrimary">{description}</span>
                </TicketPart>
                <TicketPart className={'border-radius-right d-flex text-magentaSecondary'}>
                    <Money amount={price} currency={currency} />
                </TicketPart>
            </div>
        </>
    )
}

export default Goods
